import React from 'react';

import spinner from '../../assets/img/spinner.gif';

export default () => {
    return (
        <div>
            <img
                src={spinner}
                style={{width: '200px', margin: 'auto', display: 'block'}}
                alt="Loading..."
            />
            <div className="spinner-advice">
                <h3>Cargando...</h3>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/Spinner.js